const MAX_LENGTH = 160

const nodeText = (node) =>
  node.nodeType === "text"
    ? node.value
    : (node.content || []).map(nodeText).join("")

const firstParagraph = (document) =>
  (document.content || []).find(
    (node) => node.nodeType === "paragraph" && nodeText(node).trim()
  )

// Plain text of the first non-empty paragraph across the given rich text
// documents (raw JSON strings), shortened to fit a meta description.
export const metaDescription = (richTextRaws) => {
  for (const raw of richTextRaws.filter(Boolean)) {
    const paragraph = firstParagraph(JSON.parse(raw))
    if (!paragraph) continue

    const text = nodeText(paragraph).replace(/\s+/g, " ").trim()
    if (text.length <= MAX_LENGTH) return text

    const cut = text.slice(0, MAX_LENGTH - 1)
    return `${cut.slice(0, cut.lastIndexOf(" "))}…`
  }
  return undefined
}
